<template>
  <button
    class="control-button"
    @click="player.togglePanel(PanelType.SETTINGS)"
    :aria-label="t('player.controls.settings')"
    :data-tooltip="t('player.controls.settings')"
    :aria-expanded="player.activePanel.value === PanelType.SETTINGS"
    v-html="settingsIcon"
  />
</template>

<script setup lang="ts">
import { settingsIcon } from '../../assets/icons'
import { PanelType } from '../../types'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
